const VueScrollTo = require('vue-scrollto')

export default {
  focusOnFirstInvalidOf(form) {
    for (const input of form.inputs) {
      if (!input.valid) {
        // Open expansio panel if input in it
        if (input.$parent && input.$parent.expansionPanel && !input.$parent.isActive) {
          input.$parent.expansionPanel.panelClick(input.$parent._uid)
          setTimeout(() => {
            VueScrollTo.scrollTo(input.$el, 500, { easing: 'ease', offset: -100 })
          }, 500)
        } else {
          VueScrollTo.scrollTo(input.$el, 500, { easing: 'ease', offset: -100 })
        }
        break
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/validationFocus.js